import { MediaContentShowcaseItem } from "onnit-ui/lib/module/MediaContentShowcase";

const ingredients: MediaContentShowcaseItem[] = [
    {
        image: `N-Acetyl_L-Tyrosine.png?q=40`,
        imageWidth: 560,
        imageHeight: 560,
        title: "N-Acetyl L-Tyrosine",
        summary:
            "An amino acid commonly found in animal foods.",
        detail:
            'Used by the body to make chemical messengers, L-tyrosine has been shown to support mental performance under stressful conditions (specifically, cold temperatures and noise)<span class="oui-sup">†</span>.'
    },
    {
        image: `KSM-66.png?q=40`,
        imageWidth: 560,
        imageHeight: 560,
        title: 'KSM-66<span class="oui-sup">®</span> Ashwagandha Root Extract',
        summary:
            "An adaptogenic herb, ashwagandha has been used in Ayurvedic medicine for generations.",
        detail:
            'The KSM-66<span class="oui-sup">®</span> branded extract has been shown to support the body’s stress response.<span class="oui-sup">†</span>'
    },
    {
        image: `Citicoline.png?q=40`,
        imageWidth: 560,
        imageHeight: 560,
        title: 'Cognizin<span class="oui-sup">®</span> Citicoline',
        summary:
            "A type of citicoline, a naturally-occurring brain chemical.",
        detail:
            'Helps maintain levels of other chemicals that transport messages in the brain, supporting attention and focus.<span class="oui-sup">†</span>'
    },
    {
        image: `LionsMane.png?q=40`,
        imageWidth: 560,
        imageHeight: 560,
        title: "Lion’s Mane",
        summary:
            "A mushroom native to North America.",
        detail:
            "Shown to support a positive mood state and cognitive function†."
    },
    {
        image: `L-Theanine.png?q=40`,
        imageWidth: 560,
        imageHeight: 560,
        title: "L-Theanine",
        summary:
            'An amino acid that supports the production of alpha brain waves—the electric signals in the brain associated with creativity and productivity.<span class="oui-sup">†</span>',
        detail:
            'When combined with caffeine, L-theanine has been shown to promote a state of relaxed alertness that supports performance on cognitive tasks. Think: wide awake, but not overstimulated.<span class="oui-sup">†</span>'
    },
    {
        image: `Caffeine.png?q=40`,
        imageWidth: 560,
        imageHeight: 560,
        title: "Caffeine (from Green Tea Extract)",
        summary:
            "A low dose (50mg) of the stimulant found in coffee and teas.",
        detail:
            'Even in lower doses, caffeine has been shown to promote alertness and focus, but with subjects reporting a more pleasant mood and less nervousness or restlessness than when taking higher amounts.<span class="oui-sup">†</span>'
    },
    {
        image: `Huperzia-Serrata.png?q=40`,
        imageWidth: 560,
        imageHeight: 560,
        title: "Huperzia Serrata Extract",
        summary:
            'An herbal extract containing the plant compound Huperzine A that can naturally inhibit the enzyme that breaks down the neurotransmitter acetylcholine.<span class="oui-sup">†</span>',
        detail:
            'Supports optimal acetylcholine levels.<span class="oui-sup">†</span>'
    }
];

export default ingredients;
